<template>
    <div class="w-full mobileXpadding mx-auto md:min-h-screen mb-48">
        <!-- Search Section -->
        <div class="flex flex-wrap max-w-screen-2xl mx-auto">
            <div @click="openMenu()"
                class="fixed bottom-20 CTAbottombutton right-4 bg-gradient shadow-xl cursor-pointer text-sm dark:text-white leading-none rounded-full inline-flex h-fit md:hidden z-[15] active:scale-90 transition">
                <div class="inline-flex items-center transition-colors duration-300 ease-in focus:outline-none hover:text-primary rounded-full p-4 sm:p-2 text-sm h-fit text-white dark:!text-neutral-900"
                    id="grid">
                    <svg class="h-6 w-6" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none"
                        stroke-linecap="round" stroke-linejoin="round">
                        <path stroke="none" d="M0 0h24v24H0z" />
                        <path d="M5.5 5h13a1 1 0 0 1 0.5 1.5L14 12L14 19L10 16L10 12L5 6.5a1 1 0 0 1 0.5 -1.5" />
                    </svg>
                    <span>{{ $t('Filters') }}</span>
                </div>
            </div>
            <!-- Sidebar -->
            <div v-show="menuOpen" @click.self="closeMenu()"
                class="fixed md:sticky top-0 left-0 md:top-[80px] h-screen md:h-fit overflow-y-scroll scrollbar-hide pt-24 px-3 md:px-0 md:pt-0 md:relative w-full md:w-1/4 px-0 bg-black/10 dark:bg-neutral-500/10 md:bg-transparent backdrop-blur-xs md:backdrop-filter-none z-50 md:z-1">
                <button type="button" @click="closeMenu()"
                    class="md:hidden absolute top-4 right-4 h-14 w-14 bg-white dark:bg-neutral-900 rounded-md p-2 inline-flex items-center justify-center text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-primary">
                    <span class="sr-only">Close menu</span>
                    <!-- Heroicon name: outline/x -->
                    <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                        stroke="currentColor" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                    </svg>
                </button>
                <div
                    class=" bg-white dark:bg-neutral-900 md:bg-transparent rounded-t-xl min-h-screen md:min-h-auto pb-24 md:pb-0">
                    <div class="p-4">
                        <form class="pt-2 space-y-8">
                            <div class="w-full">
                                <div class="mb-2">
                                    <div class="space-y-2">
                                        <div v-for="option in ['today', 'tomorrow', 'weekend', 'next-week']" :key="option"
                                            class="flex items-center ps-4 border border-gray-200 rounded-sm dark:border-neutral-700 group hover:bg-white dark:hover:bg-neutral-800 transition cursor-pointer active:border-primary"
                                            @click="toggleDate(option)">
                                            <input type="radio" :id="`radio-${option}`" :value="option"
                                                v-model="filters.date" name="date-radio"
                                                class="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300 dark:border-neutral-300 focus:ring-blue-500 dark:focus:ring-blue-600 dark:ring-offset-neutral-800 focus:ring-2 dark:bg-neutral-700 dark:border-neutral-600 checked:bg-primary"
                                                @click.stop>
                                            <label :for="`radio-${option}`"
                                                class="w-full py-4 ms-4 text-sm font-medium text-gray-900 dark:text-neutral-300 capitalize">
                                                {{ $t(option) }}
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <app-accordion class="p-4 mb-4 rounded hover:bg-gray-50 transition" :open="false"
                                :start-open-mobile="true">
                                <template v-slot:title>
                                    <div class="flex justify-between items-center">
                                        <label for="price-range" class="capitalize">
                                            {{ $t('Price Range') }}:
                                        </label>
                                        <div v-if="filters.price != 100"
                                            class="capitalize text-xxs text-gray-400 dark:text-neutral-500 ml-4">
                                            {{ $t('max price') }}: {{ filters.price }}
                                        </div>
                                    </div>
                                </template>
                                <template v-slot:content>
                                    <div class="mb-2">
                                        <input type="range" id="price-range" min="0" max="100" v-model="filters.price"
                                            class="w-full slider-primary">
                                    </div>
                                    <div class="flex justify-between text-gray-500 dark:text-neutral-500">
                                        <span id="minPrice" class="text-sm">€0</span>
                                        <span id="maxPrice" class="text-sm">€100</span>
                                    </div>
                                </template>
                            </app-accordion>

                            <app-accordion class="p-4 mb-4 rounded hover:bg-gray-50 transition" :open="false"
                                :start-open-mobile="true">
                                <template v-slot:title>
                                    <div class="capitalize">
                                        {{ $t('Categories') }}:
                                    </div>
                                </template>
                                <template v-slot:content>
                                    <div class="flex flex-wrap gap-2">
                                        <div v-for="item in categories" @click="setCategories(item)"
                                            :ref="'cat_' + item.slug"
                                            class="px-2 py-1 bg-neutral-200 shrink-0 dark:bg-neutral-700 rounded-full border border-neutral-300 dark:!border-neutral-500 dark:text-white capitalize flex gap-1 items-center justify-between hover:scale-110 active:scale-90 transition cursor-pointer"
                                            :class="[item.slug == filters.category ? 'border-primary dark:!border-primary text-primary' : '']">
                                            <div class="text-xs">
                                                {{ getTranslated(item.name) }}
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </app-accordion>

                            <!-- <div class="">
                                <span class="capitalize text-xxs text-gray-400 dark:text-neutral-500 mb-2">
                                    {{ $t("Categories") }}:
                                </span>
                                <div class="flex flex-wrap gap-2">
                                    <div v-for="item in categories" @click="setCategories(item)" :ref="'cat_' + item.slug"
                                        class="px-2 py-1 bg-neutral-200 shrink-0 dark:bg-neutral-700 rounded-full border border-neutral-300 dark:!border-neutral-500 dark:text-white capitalize flex gap-1 items-center justify-between hover:scale-110 active:scale-90 transition cursor-pointer"
                                        :class="[item.slug == filters.category ? 'border-primary dark:!border-primary text-primary' : '']">
                                        <div class="text-xs">
                                            {{ getTranslated(item.name) }}
                                        </div>
                                    </div>
                                </div>
                            </div> -->
                            <div class="relative mx-auto text-gray-600 relative w-full">
                                <input v-model="filters.search" ref="searchbar"
                                    class="border-2 w-full border-gray-300 dark:border-neutral-500 bg-white dark:bg-neutral-700 dark:text-white h-12 px-5 pr-16 rounded-full text-sm focus:outline-none dark:placeholder-neutral-400"
                                    type="search" name="search" placeholder="Search">
                                <button type="submit"
                                    class="absolute right-0 top-0 mt-1 mr-2 p-3 hover:bg-gray-100 dark:hover:bg-neutral-700 rounded-full">
                                    <svg class="text-gray-600 dark:text-neutral-300 h-4 w-4 fill-current"
                                        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                                        version="1.1" id="Capa_1" x="0px" y="0px" viewBox="0 0 56.966 56.966"
                                        style="enable-background:new 0 0 56.966 56.966;" xml:space="preserve" width="512px"
                                        height="512px">
                                        <path
                                            d="M55.146,51.887L41.588,37.786c3.486-4.144,5.396-9.358,5.396-14.786c0-12.682-10.318-23-23-23s-23,10.318-23,23  s10.318,23,23,23c4.761,0,9.298-1.436,13.177-4.162l13.661,14.208c0.571,0.593,1.339,0.92,2.162,0.92  c0.779,0,1.518-0.297,2.079-0.837C56.255,54.982,56.293,53.08,55.146,51.887z M23.984,6c9.374,0,17,7.626,17,17s-7.626,17-17,17  s-17-7.626-17-17S14.61,6,23.984,6z" />
                                    </svg>
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div class="w-full md:w-3/4 p-3 md:p-4" key="resultssection">
                <div v-if="hasActiveFilters"
                    class="flex items-center space-x-1 mb-3 md:mb-4 md:px-3 border-b border-neutral-300 dark:border-neutral-700 pb-3 md:pb-4 overflow-x-scroll scrollbar-hide pr-12">
                    <span @click="openMenu()" class="hidden md:block text-sm text-gray-300 dark:text-neutral-600">{{
                        $t('Filters') }} |</span>
                    <div @click="openMenu()" class="flex md:hidden items-center mr-1 text-gray-300 dark:text-neutral-600">
                        <svg class=" h-4 w-4 mr-1" aria-hidden="true" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd"
                                d="M2.628 1.601C5.028 1.206 7.49 1 10 1s4.973.206 7.372.601a.75.75 0 01.628.74v2.288a2.25 2.25 0 01-.659 1.59l-4.682 4.683a2.25 2.25 0 00-.659 1.59v3.037c0 .684-.31 1.33-.844 1.757l-1.937 1.55A.75.75 0 018 18.25v-5.757a2.25 2.25 0 00-.659-1.591L2.659 6.22A2.25 2.25 0 012 4.629V2.34a.75.75 0 01.628-.74z"
                                clip-rule="evenodd" />
                        </svg>
                        :
                    </div>
                    <template v-for="(item, index) in activeFilters">
                        <div v-if="item" @click="removeFilter(item[0])"
                            class="rounded-full flex justify-between items-center pl-2 pr-1 py-1 bg-neutral-200 shrink-0 dark:bg-neutral-700 rounded-full border border-neutral-300 dark:!border-neutral-500 dark:text-white capitalize cursor-pointer hover:bg-gray-100 dark:hover:bg-neutral-700 text-sm active:scale-90 transition">
                            <span>
                                <template v-if="item[0] == 'search'">{{ $t("Search") }}: </template>
                                <template v-if="item[0] == 'locations'">{{ $t("Location") }}: </template>
                                {{ $t(item[1]) }}
                            </span>
                            <div
                                class=" cursor-pointer hover:bg-gray-300 rounded-full dark:hover:bg-neutral-600 flex items-center justify-center h-5 w-5 ml-2">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                    stroke="currentColor" aria-hidden="true" class="h-3 w-3">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                        d="M6 18L18 6M6 6l12 12">
                                    </path>
                                </svg>
                            </div>
                        </div>
                    </template>
                </div>
                <!-- Main Content -->

                <div
                    class="w-full grid grid-cols-2 sm:grid-cols-3 md2:grid-cols-4 3xl:grid-cols-5 5xl:grid-cols-6 gap-3 md:gap-4 grid-flow-dense">
                    <a v-for="(event, index) in allEvents" :key="event.id || index"
                        :href="$homeUrl + `/events/${event.slug}`"
                        class="snap-start transition relative cursor-pointer group dark:text-white hover:bg-gray-200 active:scale-90 dark:hover:bg-neutral-800 md:p-2 rounded-xl w-full"
                        :class="event.is_promoted ? 'col-span-2' : ''">
                        <div class="bg-white dark:bg-neutral-900 rounded-lg mb-2 w-full flex justify-center items-center shadow-lg group-hover:shadow-none group-hover:scale-95 transition relative"
                            :class="event.is_promoted ? 'aspect-[2.05/1] md:aspect-[2.2/1] md2:aspect-[2.13/1]' : 'aspect-square'">
                            <div v-if="event.sold_out"
                                class="cursor-events-none h-full w-full absolute backdrop-grayscale backdrop-contrast-50 top-0 left-0 rounded-lg flex items-center justify-center">
                                <div
                                    class="w-full bg-gray-100 dark:bg-neutral-900 text-gray-500 dark:text-neutral-300 py-2 text-center text-sm">
                                    {{ $t('Sold out') }}!
                                </div>
                            </div>

                            <a v-if="event.show_promoted" @click.stop
                                :href="$baseUrl + '/termsandconditions#sponsored'"
                                target="blank"
                                class="bg-black/50 backdrop-blur-sm p-2 rounded-full absolute left-2 top-2 text-gray-200 hover:text-yellow-400 z-5 transition-all duration-500 flex items-center justify-start group/promotion max-w-[32px] hover:max-w-full overflow-hidden">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 576 512"
                                    class="w-4 h-4 shrink-0">
                                    <path
                                        d="M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34L209.7 220.6c-9.1 18.2-32.7 23.4-48.6 10.7L72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0L86.4 427.4c5.5 30.4 32 52.6 63 52.6H426.6c30.9 0 57.4-22.1 63-52.6L535.3 176c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-89.1 71.3c-15.9 12.7-39.5 7.5-48.6-10.7L309 106z">
                                    </path>
                                </svg>
                            </a>

                            <!-- Replace this with your actual like button component or implementation -->
                            <likebutton :id="`e_${event.id}`"
                                background="absolute top-3 right-3 bg-black/50 backdrop-blur-sm" color="text-gray-100" />

                            <img v-if="event.image_link" class="w-full h-full object-cover rounded-lg pointer-events-none"
                                :src="event.image_link" alt="Event image" loading="lazy" />
                            <div v-else class="bg-gray-300 dark:bg-neutral-600 w-full h-full rounded-lg">
                            </div>
                        </div>
                        <span class="capitalize text-xs text-gray-400 dark:text-neutral-500">
                            {{ getEventLabel(event) }}
                        </span>

                        <div class="w-full overflow-hidden relative h-4 xs:h-5 sm:h-6">
                            <span class="scroll_long_text capitalize text-xs xs:text-sm sm:text-base">
                                {{ getTranslated(event.name) }}
                            </span>
                        </div>
                        <div class="w-full overflow-hidden relative h-4">
                            <span class="scroll_long_text text-xs text-primary capitalize">
                                <template v-if="event.event_repeats && event.event_repeats.length > 0">
                                    {{ formatRepeats(event) }}
                                </template>
                                <template v-else-if="event.event_items && event.event_items.length > 0">
                                    {{ formatEventItems(event) }}
                                </template>
                                <template v-else>
                                    {{ formatDate(event.start, event.end) }}
                                </template>
                            </span>
                        </div>

                        <span v-if="event.price !== undefined && event.price !== null"
                            class="max-w-[160px] sm:max-w-[200px] capitalize text-xs text-gray-700 dark:text-neutral-400">
                            {{ formattedPrice(event) }}
                        </span>
                    </a>
                </div>
                <infinite-loading ref="infiniteLoading" @infinite="infiniteHandler" class="w-full">
                    <div slot="spinner"
                        class="w-full grid grid-cols-2 sm:grid-cols-3 md2:grid-cols-4 3xl:grid-cols-5 5xl:grid-cols-6 gap-4">
                        <div role="status" v-for="n in 12"
                            class="flex flex-col snap-start transition relative cursor-pointer group dark:text-white hover:bg-gray-200 active:scale-90 dark:hover:bg-neutral-800 md:p-2 rounded-xl w-auto">

                            <div
                                class="w-full h-full aspect-square object-cover rounded-lg bg-gray-300 dark:bg-neutral-700 blur-lg rounded-2xl animate-pulse">
                            </div>
                            <div class="h-3 bg-gray-200 dark:bg-neutral-700 rounded-full w-32 mb-2 animate-pulse blur">
                            </div>
                            <div
                                class="h-4 xs:h-5 sm:h-6 bg-gray-200 dark:bg-neutral-700 rounded-full w-40 mb-2 animate-pulse blur">
                            </div>
                            <div class="h-2 bg-gray-200 dark:bg-neutral-700 rounded-full mb-1 animate-pulse blur"></div>
                            <div class="h-2 bg-gray-200 dark:bg-neutral-700 rounded-full mb-1 animate-pulse blur"></div>
                        </div>
                    </div>
                    <div slot="no-more"></div>
                    <div slot="no-results"
                        class="flex flex-col justify-center items-center w-full gap-4 rounded-xl border-t border-gray-200 mt-4">
                    </div>
                </infinite-loading>
            </div>
        </div>
    </div>
</template>
  
<script>
import { useTypeMeta } from '../helpers/useTypeMeta'
import eventHelpers from '../../eventHelpers'
const { debounce } = require('lodash');
import InfiniteLoading from 'vue-infinite-loading';
import moment from "moment";

export default {
    name: 'events_index',
    components: {
        InfiniteLoading
    },
    props: {
        events: {
            type: Array,
            default: () => [],
        },
        categories: {
            type: Array,
            default: () => [],
        }
    },

    data() {
        return {
            allEvents: [],
            menuState: false,
            isMd: window.matchMedia("(min-width: 768px)").matches,
            previousSearch: null,
            page: 1,
            last_page: null,
            forceUpdate: 0,
            isLoading: false,
            resultsChanged: false,
            initfilters: false,
            filters: {
                search: '',
                date: '',
                dateFrom: '',
                dateTo: '',
                locations: '',
                category: '',
                parent_event: null,
                price: 100,
            },
        };
    },

    mounted() {
        const category = new URLSearchParams(window.location.search).get('category');
        if (category) {
            this.filters.category = category;
        }

        const search = new URLSearchParams(window.location.search).get('search');
        if (search) {
            this.filters.search = search;
        }

        const event = new URLSearchParams(window.location.search).get('event');
        if (event) {
            this.filters.parent_event = event;
        }

        // Listen to resize changes
        const mq = window.matchMedia("(min-width: 768px)");
        const handler = (e) => {
            if (e.matches) {
                $("body").removeClass("scroll_lock")
            }
            this.isMd = e.matches;
        };
        mq.addEventListener("change", handler);
        this.$once("hook:beforeDestroy", () => mq.removeEventListener("change", handler));

    },
    computed: {
        activeFilters() {
            return Object.entries(this.filters).filter(([key, value]) => {
                if (!value) return false;

                if (key == 'price' && value == 100) {
                    return false;
                }

                if ((key === 'dateFrom' || key === 'dateTo') && this.filters.date) {
                    return false;
                }

                return true;
            });
        },
        hasActiveFilters() {
            return this.activeFilters.length > 0;
        },
        menuOpen() {
            if (this.isMd) return true;
            return this.menuState;
        }
    },
    created() {
        const params = new URLSearchParams(window.location.search);

        Object.keys(this.filters).forEach(key => {
            if (params.has(key)) {
                // Special case: numbers should stay numbers
                if (key === "price") {
                    this.filters[key] = parseFloat(params.get(key)) || 100;
                } else {
                    this.filters[key] = params.get(key);
                }
            }
        });

        this.setDateFromTo(this.filters.date)
    },
    methods: {
        ...eventHelpers,
        toggleDate(option) {
            // If the clicked option is already selected, clear it
            if (this.filters.date === option) {
                this.filters.date = null;
            } else {
                this.filters.date = option;
            }
        },
        getEventLabel(event) {
            const hasProps = event.properties && event.properties.length > 0
            const hasLocs = event.locations && event.locations.length > 0

            if (hasProps) {
                const first = event.properties[0].name
                return event.properties.length > 1
                    ? `${first} ${this.$t('and more')}...`
                    : first
            }

            if (hasLocs) {
                const first = this.getTranslated(event.locations[0].name)
                return event.locations.length > 1
                    ? `${first} ${this.$t('and more')}...`
                    : first
            }

            return ''
        },
        removeFilter(filter) {
            if (filter === "date") {
                this.filters.date = "";
                this.filters.dateFrom = "";
                this.filters.dateTo = "";
            } else if (filter === "price") {
                this.filters.price = 100; // reset to default
            } else {
                this.filters[filter] = "";
            }

            const url = new URL(window.location.href);
            url.searchParams.delete(filter);
            window.history.replaceState({}, '', url);
        },
        openMenu() {
            $("body").addClass("scroll_lock")
            this.menuState = true;
        },
        closeMenu() {
            $("body").removeClass("scroll_lock")
            this.menuState = false;
            if (this.resultsChanged) {
                window.scrollTo({
                    top: 0,
                    behavior: "smooth"
                });
            }
        },
        async infiniteHandler($state) {
            this.isLoading = true;

            if (!this.last_page || this.page < this.last_page) {
                try {
                    const filtered = Object.fromEntries(
                        Object.entries(this.filters).filter(([key, value]) => value !== null && value !== 100)
                    );
                    const query = new URLSearchParams(filtered).toString();
                    const response = await fetch(`/resources/events?page=${this.page}&${query}`, {
                        credentials: 'same-origin',
                        headers: {
                            'Accept': 'application/json',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                        },
                    });
                    const result = await response.json();

                    if (result && result.data && result.data.length > 0) {
                        this.allEvents.push(...result.data); // mutate the local array
                        this.page++;
                        this.forceUpdate++;

                        this.last_page = result.last_page;
                        if (this.page > result.last_page) {
                            $state.loaded();
                            $state.complete();
                        } else {
                            $state.loaded();
                        }
                    } else {
                        $state.complete(); // no more data
                    }
                } catch (error) {
                    console.error("Error fetching events:", error);
                    $state.complete(); // fail silently
                } finally {
                    this.isLoading = false;
                }
            } else {
                $state.complete();
            }
        },
        getRelativeDayName(date, endDate = null) {
            if (!date) return "";

            const today = new Date();
            const target = new Date(date.getFullYear(), date.getMonth(), date.getDate());

            // If endDate is provided and ongoing, treat as today
            if (endDate && today >= date && today <= endDate) {
                return this.$t('today');
            }

            const diffTime = target - new Date(today.getFullYear(), today.getMonth(), today.getDate());
            const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

            const locale = this.$i18n ? this.$i18n.locale : undefined;
            if (diffDays === 0) return this.$t('today');
            if (diffDays === 1) return this.$t('tomorrow');
            if (diffDays > 1 && diffDays <= 7) return date.toLocaleDateString(locale, { weekday: 'long' });

            return date.toLocaleDateString(locale, { day: '2-digit', month: 'short' });
        },
        formattedPrice(event) {
            const price = Number(event.price);
            if (isNaN(price)) {
                return ''; // or some default text if you want
            }
            if (price > 0) {
                return `€ ${price.toFixed(2)}`;
            } else if (price < 0) {
                return this.$t('Event ticket required');
            } else if (price === 0) {
                return 'Free!';
            }
            return '';
        },
        getTranslated(item, lang = 'en') {
            if (!item) return '';

            const translations = item[lang] || item['en'];
            return translations;
        },
        searchEvents: _.debounce(function () {
            this.allEvents = [];
            this.page = 1;
            this.last_page = null;
            this.forceUpdate++;

            if (this.filters.search) {
                const url = new URL(window.location.href);
                url.searchParams.set('search', this.filters.search);
                window.history.replaceState({}, '', url);
            } else {
                this.filters.search = '';
                const url = new URL(window.location.href);
                url.searchParams.delete('search');
                window.history.replaceState({}, '', url);
            }

            // Reset the infinite loader to start fetching from page 1 with new filters
            this.$nextTick(() => {
                if (this.$refs.infiniteLoading) {
                    this.$refs.infiniteLoading.stateChanger.reset();
                }
            });
        }, 300),

        setCategories(item) {
            if (this.filters.category == item.slug) {
                this.filters.category = '';
                const url = new URL(window.location.href);
                url.searchParams.delete('category');
                window.history.replaceState({}, '', url);
            } else {
                this.filters.category = item.slug;
                const url = new URL(window.location.href);
                url.searchParams.set('category', item.slug);
                window.history.replaceState({}, '', url);
            }

        },
        formatDateForUrl(date) {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
            const year = date.getFullYear();

            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');

            return `${day}${month}${year}-${hours}${minutes}`; // e.g., 27082025-1425
        },
        setDateFromTo(date) {
            const today = new Date();
            let dateFrom = null;
            let dateTo = null;

            switch (date) {
                case 'today':
                    dateFrom = new Date(today.setHours(0, 0, 0, 0));
                    dateTo = new Date(today.setHours(23, 59, 59, 999));
                    break;

                case 'tomorrow':
                    const tomorrow = new Date();
                    tomorrow.setDate(tomorrow.getDate() + 1);
                    dateFrom = new Date(tomorrow.setHours(0, 0, 0, 0));
                    dateTo = new Date(tomorrow.setHours(23, 59, 59, 999));
                    break;

                case 'weekend':
                    const currentDay = today.getDay(); // 0 = Sun, 5 = Fri
                    const friday = new Date(today);

                    if (currentDay >= 5) {
                        friday.setDate(today.getDate() - (currentDay - 5));
                    } else {
                        friday.setDate(today.getDate() + (5 - currentDay));
                    }

                    dateFrom = new Date(friday.setHours(0, 0, 0, 0));
                    const sunday = new Date(dateFrom);
                    sunday.setDate(dateFrom.getDate() + 2);
                    dateTo = new Date(sunday.setHours(23, 59, 59, 999));
                    break;

                case 'next-week':
                    const nextMonday = new Date(today);
                    const dayOfWeek = today.getDay(); // 0 = Sun
                    nextMonday.setDate(today.getDate() + ((8 - dayOfWeek) % 7 || 7));
                    dateFrom = new Date(nextMonday.setHours(0, 0, 0, 0));

                    const nextSunday = new Date(dateFrom);
                    nextSunday.setDate(nextMonday.getDate() + 6);
                    dateTo = new Date(nextSunday.setHours(23, 59, 59, 999));
                    break;
            }

            const newDateFrom = this.formatDateForUrl(dateFrom);
            const newDateTo = this.formatDateForUrl(dateTo);

            let changed = false;

            if (this.filters.dateFrom !== newDateFrom) {
                this.filters.dateFrom = newDateFrom;
                changed = true;
            }

            if (this.filters.dateTo !== newDateTo) {
                this.filters.dateTo = newDateTo;
                changed = true;
            }

            return changed;
        }
    },
    watch: {
        filters: {
            handler: _.debounce(function (val, oldVal) {
                const searchChanged = val?.search != this.previousSearch;
                const url = new URL(window.location.href);

                // Add all filters to URL except dateFrom and dateTo
                Object.entries(val).forEach(([key, value]) => {
                    if (key === 'dateFrom' || key === 'dateTo') return;

                    if (value !== '' && value !== null && !(key === 'price' && value === 100)) {
                        url.searchParams.set(key, value);
                    } else {
                        url.searchParams.delete(key);
                    }
                });

                // Handle date separately
                if (val.date) {
                    url.searchParams.set('date', val.date);
                    if (this.setDateFromTo(val.date)) {
                        if (this.filters.dateFrom !== null) this.filters.dateFrom = this.filters.dateFrom;
                        if (this.filters.dateTo !== null) this.filters.dateTo = this.filters.dateTo;
                    }
                } else {
                    url.searchParams.delete('date');
                    this.filters.dateFrom = null;
                    this.filters.dateTo = null;
                }

                window.history.replaceState({}, '', url);

                // Determine if "search" was changed

                this.$nextTick(() => {
                    if (!searchChanged) {
                        this.closeMenu(); // only close menu if not search
                        window.scrollTo({
                            top: 0,
                            behavior: "smooth"
                        });
                    }
                    this.resultsChanged = true;
                    this.searchEvents();
                    this.previousSearch = val.search;
                });
            }, 300),
            immediate: false,
            deep: true
        },
    },
    beforeDestroy() {
    }
};
</script>